import React, { useEffect, useState } from "react";

import CardClient from "../content/CardClient";

import { Card, Button, Collapse } from "react-bootstrap";
import { CardDeudas } from "../content/CardDeudas";

import { formatDefaultDate } from "../../../utils/utilities";

export default function MisDeudas() {
  return (
    <>
      <section className="content">
        <div className="container-fluid mt-2 p-1">
          <CardDeudas
            fw={true}
            title="Garantías"
            color="yellow"
            urlApi="/deudaEnvases/garantía/pag"
            tipo_accion="pendientes"
            vendedor="true"
            headers={[
              {
                label: "Deudor",
                value: ["envaseDeudorCodigo", "envaseDeudorDetalles"],
                type: "default",
                multiLine: true,
                lineBold: [0],
                alignRight: false,
              },
              {
                label: "Detalles",
                value: ["metodo_intercambio"],
                type: "default",
                multiLine: true,
                lineBold: [0],
                alignRight: true,
              },
              {
                label: "Cuaderno",
                value: ["cuaderno"],
                type: "default",
                multiLine: true,
                lineBold: [0],
                alignRight: true,
              },
              {
                label: "Monto inicial Bs.",
                value: ["saldo_inicial"],
                type: "default",
                multiLine: true,
                lineBold: [0],
                alignRight: true,
              },
              {
                label: "Saldo Bs.",
                value: ["saldo"],
                type: "default",
                multiLine: true,
                lineBold: [0],
                alignRight: true,
              },
              // {
              //     label: 'Estado',
              //     value: ['estado'],
              //     type: 'default',
              //     multiLine: true,
              //     lineBold: [0],
              //     alignRight: true
              // },
              {
                label: "Fecha de Prestamo",
                value: ["createdAt"],
                type: "default",
                multiLine: true,
                lineBold: [0],
                alignRight: true,
                transform: true,
                func: formatDefaultDate,
              },
              // {
              //   label: "Fecha límite",
              //   value: ["fecha_limite"],
              //   type: "default",
              //   multiLine: true,
              //   lineBold: [0],
              //   alignRight: true,
              //   transform: true,
              //   func: formatDefaultDate,
              // },
            ]}
          />
        </div>
      </section>
    </>
  );
}
